import { ChangeDetectorRef, Component, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil, take } from 'rxjs/operators';
import { TIMEZONE_ZONES, TimezoneOption } from 'src/app/shared/utils/timezone-zones.constant';

import { Constant } from 'src/app/constant/constant';
import { CommonService } from 'src/app/services/common.service';
import { CountryStateCityService } from 'src/app/services/country-state-city.service';
import { CompaniesService } from 'src/app/services/companies.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { UsersService } from 'src/app/services/users.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { IndustryTypeService } from 'src/app/services/industry-type.service';
import { BussinessTypeService } from 'src/app/services/bussiness-type.service';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import { SimpleDynamicFormComponent } from 'src/app/shared/simple-form/simple-dynamic-form/simple-dynamic-form.component';
import { UsercallreportService } from 'src/app/services/usercallreport.service';
import { PaymentTypeService } from 'src/app/services/payment-type.service';
import { PosSupplierService } from 'src/app/services/pos-supplier.service';
import { PoswarehouseService } from 'src/app/services/poswarehouse.service';
import { DealsStageService } from 'src/app/services/deals-stage.service';
import { TrackerService } from 'src/app/services/tracker.service';
import { TaskStatusService } from 'src/app/services/task-status.service';
import { PriorityService } from 'src/app/services/priority.service';
@Component({
  selector: 'calsoft-field-edit-dialog',
  templateUrl: './field-edit-dialog.component.html',
  styleUrls: ['./field-edit-dialog.component.scss']
})
export class FieldEditDialogComponent implements OnInit, OnDestroy {

  @ViewChild('dynamicForm') dynamicForm: any;


  url = '';
  sanitizedUrl = '';


  data: any;
  filteredcountryTypeList: any;
  countryTypeList: any;
  countryFilterControl: UntypedFormControl = new UntypedFormControl();
  filteredleadStatusTypeList: any;
  leadStatusList: any;
  leadStatusTypeList: any;
  leadStatusFilterControl: UntypedFormControl = new UntypedFormControl();
  optionValues: any[] = [];
  filteredOptionValues: any[] = [];
  optionFilterControl: UntypedFormControl = new UntypedFormControl();
  tagsList: any;
  filteredTagsList: any;
  tagFilterControl: UntypedFormControl = new UntypedFormControl();

  lifeCyleStageList: any = [
    { name: 'Lead', value: 'Lead' },
    { name: 'Customer', value: 'Customer' },
    { name: 'Sales Qualified Lead', value: 'Sales Qualified Lead' },

  ];

  constructor(
    public dialogRef: MatDialogRef<FieldEditDialogComponent>,
    private router: Router,
    private usersService: UsersService,
    private companiesService: CompaniesService,
    private commonService: CommonService,
    private leadStatusService: LeadStatusService,
    private leadSourceService: LeadSourceService,
    private industryTypeService: IndustryTypeService,
    private bussinessTypeService: BussinessTypeService,
    private tagesStatusService: TagesStatusService,
    private countryStateCityService: CountryStateCityService,
    private dynamicFormLabelService: DynamicFormLabelService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private usercallreportService: UsercallreportService,
    private paymentTypeService: PaymentTypeService,
    private posSupplierService: PosSupplierService,
    private poswarehouseService: PoswarehouseService,
    private dealsStageService: DealsStageService,
    private trackerService: TrackerService,
    private taskStatusService: TaskStatusService,
    private priorityService: PriorityService,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
    this.data = data;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;


  originalValue: any;
  patchValues: any = {};
  firstFormGroup: any = { value: {} };
  formInit: boolean = false;
  regConfig: any[] = [];
  finalValueForm: any;
  defaultForm: boolean = false;
  clearSecondaryStatus: boolean = false;

  ngOnInit() {
    this.originalValue = this.data.value;

    if (this.data) {
      let type = (this.data.type || '').toString().toLowerCase().trim();
      if (type === 'varchar' || type === 'string' || type === 'char') {
        type = 'text';
      } else if (type === 'int' || type === 'integer' || type === 'double' || type === 'float') {
        type = 'number';
      }

      if (!['text', 'number', 'select', 'multiselect', 'boolean', 'date'].includes(type)) {
        type = 'text';
      }

      const lbl = (this.data.label || '').toLowerCase();
      if (lbl.includes('state') || lbl.includes('city') || lbl.includes('country')) {
        type = 'select';
      }

      this.data.type = type;
    }

    if (this.data.type === 'boolean') {
      this.data.value =
        this.data.value === 'YES' ? 1 :
          this.data.value === 'NO' ? 0 :
            this.data.value;
    }

    if (this.data.type === 'date' && this.data.value) {
      const v = this.data.value.replace(' ', 'T');
      this.data.value = new Date(v);
    }



    if (this.data?.patchValues) {
      this.patchValues = { ...this.data.patchValues };
    } else if (this.data?.element) {
      const el = this.data.element;
      for (let i = 1; i <= 10; i++) {
        let cf = el['customField' + i];
        if (cf) {
          if (typeof cf === 'string') {
            try {
              cf = JSON.parse(cf);
            } catch (e) { }
          }
          if (cf && typeof cf === 'object') {
            Object.assign(this.patchValues, cf);
          }
        }
      }
    }

    this.getUserDropDownList();
    this.usertypeYFilter();
    this.getAllCountry();
    this.countrYFilter();
    this.getLeadStatusList();
    this.getLeadSourceDownList();
    this.LeadSourceYFilter();
    this.parseOptionValues();
    this.handleInitialValue();
    this.optionFilterInit();
    this.normalizeSelectValue();
    this.getAllIndustry();
    this.IndustryYFilter();
    this.getAllBusiness();
    this.BusinessYFilter();
    this.getTagsList();
    this.getAllUserCallStatusList();
    this.getPaymentList();
    this.getAllSupplierList();
    this.getAllWareHouseList();
    this.getDealStage();
    this.getTrackerDropDownList();
    this.getTaskStatusDownList();
    this.getPriorityDropDownList();
    this.initTimeZones();
    this.initLocationData();

  }



  normalizeSelectValue() {

    if (this.data.type == 'select') {
      if (!this.optionValues?.length || !this.data?.value) return;

      const current = this.data.value.toString().trim().toLowerCase();

      let match =
        this.optionValues.find(o => o.value == current) ||
        this.optionValues.find(o => o.viewValue.toLowerCase() === current) ||
        this.optionValues.find(o => o.viewValue.toLowerCase().startsWith(current)); // 🔥 fallback

      if (match) {
        this.data.value = match.value;
        this.cdr.detectChanges();
      }
    }

  }






  handleInitialValue() {
    if (this.data.type === 'multiselect' && typeof this.data.value === 'string') {
      this.data.value = this.data.value.split(',').map(s => s.trim()).filter(s => s !== '');
    }
  }


  save() {

    if (this.data.label === 'Phone Number' && this.data.value) {
      this.data.value = this.data.value.toString().replace(/\./g, '');
    }

    if (this.data.label === 'Mobile Number' && this.data.value) {
      this.data.value = this.data.value.toString().replace(/\./g, '');
    }

    if (
      this.data.isRequired == 1 &&
      (!this.data.value || (Array.isArray(this.data.value) && this.data.value.length === 0))
    ) {
      return;
    }



    let finalValue = this.data.value;
    let displayValue = this.data.value;


    if (this.data.type === 'date' && this.data.value) {
      const d = new Date(this.data.value);
      // Format as local date-time string (no UTC conversion) to prevent timezone day shift
      const pad = (n: number) => n.toString().padStart(2, '0');
      finalValue = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      displayValue = finalValue;
    }


    if (this.data.label === 'Tag Name' || this.data.label === 'Tag') {
      const match = this.tagsList.find(o => o.statusId == this.data.value);
      if (match) {
        finalValue = match.statusId;
        displayValue = match.statusName;
      }
    } else if (this.data.label === 'Industry Type') {
      const match = this.industryList?.find(o => o.statusId == this.data.value);
      if (match) {
        finalValue = match.statusId;
        displayValue = match.statusName;
      }
    } else if (this.data.label === 'Business Type') {
      const match = this.BusinessList?.find(o => o.statusId == this.data.value);
      if (match) {
        finalValue = match.statusId;
        displayValue = match.statusName;
      }
    } else if (this.data.label === 'Status Name' || this.data.label === 'Lead Status') {
      const match = this.leadStatusList?.find(o => o.statusId == this.data.value);
      if (match) {
        finalValue = match.statusId;
        displayValue = match.statusName;
      }
    } else if (this.data.label === 'Lead Source') {
      const match = this.LeadSourceList?.find(o => o.sourceId == this.data.value);
      if (match) {
        finalValue = match.sourceId;
        displayValue = match.sourceName;
      }
    } else if (this.optionValues.length > 0) {

      if (this.data.type === 'multiselect') {

        const ids = Array.isArray(this.data.value)
          ? this.data.value
          : this.data.value.split(',').map(v => v.trim());

        const normalizedIds = ids.map(v => {
          const m = this.optionValues.find(o => o.value == v || o.viewValue == v);
          return m?.value;
        }).filter(Boolean);

        finalValue = normalizedIds.join(' , ');

        displayValue = normalizedIds
          .map(id => this.optionValues.find(o => o.value == id)?.viewValue)
          .join(' , ');

      } else {
        const match = this.optionValues.find(
          o => o.value == this.data.value || o.viewValue == this.data.value
        );

        if (match) {
          const cameAsId = this.optionValues.some(o => o.value == this.originalValue);
          finalValue = cameAsId ? match.value : match.viewValue;
          displayValue = match.viewValue;
        }
      }
    }

    const dynamicKeys = (this.regConfig || []).map(f => f.name).filter(Boolean);
    const secondaryFormData: any = {};

    // 1. Populate from patchValues (pre-filled lead data)
    dynamicKeys.forEach(k => {
      if (this.patchValues && this.patchValues[k] !== undefined) {
        secondaryFormData[k] = this.patchValues[k];
      }
    });

    // 2. Override with any manual changes captured in finalValueForm
    if (this.finalValueForm) {
      dynamicKeys.forEach(k => {
        if (this.finalValueForm[k] !== undefined) {
          secondaryFormData[k] = this.finalValueForm[k];
        }
      });
    }

    const firstDynamicKey = dynamicKeys[0];
    if (firstDynamicKey && secondaryFormData[firstDynamicKey] !== undefined) {
      secondaryFormData['secondaryLeadStatus'] = secondaryFormData[firstDynamicKey];
    }

    this.dialogRef.close({
      value: finalValue,
      display: displayValue,
      secondaryFormData: Object.keys(secondaryFormData).length > 0 ? secondaryFormData : null,
      clearSecondaryStatus: this.clearSecondaryStatus
    });
  }


  close() {
    this.dialogRef.close();
  }

  onFormSubmitted(event) {
    this.finalValueForm = event;
  }

  createDynamicForm(event, formGroupId, statusId) {
    if (event.isUserInput != false) {
      this.patchValues.LeadStatus = statusId;
      this.firstFormGroup.value.LeadStatus = statusId;
      this.formInit = false;
      this.regConfig = [];
      this.finalValueForm = null;

      if (formGroupId) {
        this.clearSecondaryStatus = false;
        this.getFormArray(formGroupId);
      } else {
        // No secondary status for this lead status — clear existing secondary value
        this.clearSecondaryStatus = true;
        this.defaultForm = false;
        this.cdr.detectChanges();
      }
    }
  }

  normalizeKey(key: string): string {
    return (key || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/_/g, '');
  }

  getFormArray(formGroupId) {
    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {
      let value: any = data;
      if (value.length > 0) {
        this.regConfig = value;
        const mappedPatchValues: any = { ...this.patchValues };
        this.regConfig.forEach((field, index) => {
          if (field.name) {
            const normalizedFieldName = this.normalizeKey(field.name);
            let found = false;
            for (const key of Object.keys(this.patchValues)) {
              if (this.normalizeKey(key) === normalizedFieldName) {
                mappedPatchValues[field.name] = this.patchValues[key];
                found = true;
                break;
              }
            }
            if (!found && index === 0) {
              let fallbackValue = this.patchValues['secondaryLeadStatus'] ??
                this.patchValues['SecondaryLeadStatus'] ??
                this.data.element?.secondaryLeadStatus ??
                this.data.element?.SecondaryLeadStatus;
              if (fallbackValue !== undefined && fallbackValue !== null) {
                if (typeof fallbackValue === 'string') {
                  fallbackValue = fallbackValue.trim();
                }
                mappedPatchValues[field.name] = fallbackValue;
              }
            }
          }
        });
        this.patchValues = mappedPatchValues;

        this.formInit = true;
        this.defaultForm = true;
        this.cdr.detectChanges();
      } else {
        this.defaultForm = false;
        this.clearSecondaryStatus = true;
      }
    });
  }

  saveNew(event) {
    this.finalValueForm = event;
  }

  booleanField: any = [
    { "value": 1, "viewValue": "Yes" },
    { "value": 0, "viewValue": "No" },
  ]

  onOwnerSelected(event, option, element) {
    if (event.isUserInput != false) {
      element['ownerId'] = option.entityId;
      element['ownerEmail'] = option.email;
    }
  }


  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();

  getUserDropDownList() {

    let val: any = localStorage.getItem('userType')

    if (val == null) {
      val = 0;
    } else if (val == 'salesUser') {
      val = 1;
    } else {
      val = 0;
    }

    if (!this.router.url.includes('crmAnalytics') && val == 0) {

      this.usersService.getAllUserStatusDropDown().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    } else {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    }

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }

  getAllCountry() {

    this.commonService.getCountryList().subscribe(
      res => {
        this.countryTypeList = res;
        this.filteredcountryTypeList = this.countryTypeList;
      },
    )
  }
  countrYFilter() {
    this.countryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.countryFilter();
      });
  }

  protected countryFilter() {
    if (!this.countryTypeList) {
      return;
    }

    // get the search keyword
    let search = this.countryFilterControl.value;
    if (!search) {
      this.filteredcountryTypeList = this.countryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredcountryTypeList = this.countryTypeList.filter(country => country['countryName'].toLowerCase().indexOf(search) > -1)
  }

  companyList: any;

  getCompanyData(value) {

    if (value != '') {

      let sortParam = 'updatedDate' + "," + Constant.Dsc;

      let search = "name:" + '*' + value.trim() + '*'
        + "' OR phoneNumber:" + '*' + value.trim() + '*'
        + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


      this.companiesService.getCompanyBySearchAll(search, this.page, this.size, sortParam).subscribe(
        res => {

          this.companyList = res['content'];

        },
        error => {

        })


    }


  }

  onCompanySelected(event, option, element) {
    if (event.isUserInput && option?.entityId) {

      element['companyId'] = option.entityId;
      element['company'] = option.name;


      element['CompanyId'] = option.entityId;
      element['Company'] = option.name;


    } else {
      element['companyId'] = null;
      element['company'] = '';
      element['CompanyId'] = null;
      element['Company'] = '';
    }
  }

  addNewCompany(element, companyName) {
    // Trim and validate
    const name = (companyName || '').toString().trim();
    if (!name) {
      return;
    }

    const object: any = {
      company: name,
      owner: element?.ownerEmail || '',
      ownerId: element?.ownerId || '',
      entityId: element?.CompanyId || element?.companyId || null,
    };

    this.companiesService.addCompanyName(object).subscribe(
      (response) => {
        if (response && response['status_code'] == Constant.RESPONSE_SUCCESS) {
          const resData = response['data'] || {};
          this.data.value = resData['name'] || name;
          if (element) {
            element['Company'] = resData['name'] || name;
            element['CompanyId'] = resData['entityId'] || null;
            element['company'] = resData['name'] || name;
            element['companyId'] = resData['entityId'] || null;
          }
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        } else {
          this.snackBar.open(response?.['status_message'] || 'Failed to add company', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      }, (err) => {
        this.snackBar.open('Failed to add company', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
  }


  getLeadStatusList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.leadStatusList = res;
        this.leadStatusTypeList = res;
        this.filteredleadStatusTypeList = this.leadStatusTypeList;

        if (this.data.label == 'Status Name' || this.data.label == 'Lead Status') {
          const match = this.leadStatusList.find(s => s.statusId == this.data.value || s.statusName == this.data.value);
          if (match) {
            this.data.value = match.statusId;

            if (match.dynamicFormGroupId) {
              this.patchValues.LeadStatus = match.statusId;
              this.firstFormGroup.value.LeadStatus = match.statusId;
              this.formInit = false;
              this.getFormArray(match.dynamicFormGroupId);
            }
          }
        }
      },
      error => {
      }
    )
  }

  LeadStatusYFilter() {
    this.leadStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.leadStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadStatusFilterControl.value;
    if (!search) {
      this.filteredleadStatusTypeList = this.leadStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadStatusTypeList = this.leadStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }

  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {

    this.leadSourceService.getAllLeadSourceDropDown().subscribe(
      res => {
        this.LeadSourceList = res;
        this.LeadSourceTypeList = res;
        this.filteredLeadSourceTypeList = this.LeadSourceTypeList;

      },
      error => {
      })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  parseOptionValues() {
    const valString = this.data?.optionValues || '';
    const idString = this.data?.optionId || '';

    if (valString) {
      const vals = valString.split(',').map(v => v.trim());
      const ids = idString.split(',').map(v => v.trim());

      this.optionValues = vals.map((v, i) => ({
        viewValue: v,
        value: ids[i] || v
      }));
    } else {
      this.optionValues = [];
    }
    this.filteredOptionValues = this.optionValues.slice();
  }

  optionFilterInit() {
    this.optionFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.applyOptionFilter();
      });
  }

  protected applyOptionFilter() {
    if (!this.optionValues) {
      return;
    }
    let search = this.optionFilterControl.value;
    if (!search) {
      this.filteredOptionValues = this.optionValues.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredOptionValues = this.optionValues.filter(opt =>
      opt.viewValue.toLowerCase().indexOf(search) > -1
    );
  }


  // Industry Type
  industryList: any = [];
  industryTypeList: any = [];
  filteredindustryTypeList: any = [];
  industryFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllIndustry() {
    this.industryTypeService.getAllIndustryTypeDropDown(6).subscribe(
      data => {
        this.industryList = data;
        this.industryTypeList = data;
        this.filteredindustryTypeList = this.industryTypeList;
        this.cdr.markForCheck();
      },
      error => {
      }
    )
  }

  IndustryYFilter() {
    this.industryFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.industryFilter();
      });
  }

  protected industryFilter() {
    if (!this.industryTypeList) {
      return;
    }
    let search = this.industryFilterControl.value;
    if (!search) {
      this.filteredindustryTypeList = this.industryTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredindustryTypeList = this.industryTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
    this.cdr.markForCheck();
  }

  // Business Type
  BusinessList: any = [];
  BusinessTypeList: any = [];
  filteredBusinessTypeList: any = [];
  BusinessFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllBusiness() {
    this.bussinessTypeService.getAllBusinessDropDown(7).subscribe(
      data => {
        this.BusinessList = data;
        this.BusinessTypeList = data;
        this.filteredBusinessTypeList = this.BusinessTypeList;
        this.cdr.markForCheck();
      },
      error => {
      }
    )
  }

  BusinessYFilter() {
    this.BusinessFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.BusinessFilter();
      });
  }

  protected BusinessFilter() {
    if (!this.BusinessTypeList) {
      return;
    }
    let search = this.BusinessFilterControl.value;
    if (!search) {
      this.filteredBusinessTypeList = this.BusinessTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBusinessTypeList = this.BusinessTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
    this.cdr.markForCheck();
  }


  getTagsList() {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      (res: any) => {
        this.tagsList = res;
        this.filteredTagsList = res;

        // 🔥 Pre-select if current value is string name
        if (this.data.label === 'Tag Name' || this.data.label === 'Tag') {
          const match = (res as any[]).find(t =>
            t.statusName === this.data.value ||
            t.statusId == this.data.value
          );

          if (match) {
            this.data.value = match.statusId;
          }
        }
        this.cdr.markForCheck();
      },
      error => {
      }
    )
  }

  tagYFilter() {
    this.tagFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagFilter();
      });
  }


  protected tagFilter() {
    if (!this.tagsList) {
      return;
    }
    // get the search keyword
    let search = this.tagFilterControl.value;
    if (!search) {
      this.filteredTagsList = this.tagsList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredTagsList = this.tagsList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }


  // User Call Status
  UserCallStatusList: any = [];
  UserCallStatusTypeList: any = [];
  filteredUserCallStatusTypeList: any = [];
  userCallStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllUserCallStatusList() {
    this.usercallreportService.getAllUserStatusDropDown().subscribe(
      (data: any) => {
        const raw: any[] = Array.isArray(data) ? data : [];
        const normalized = raw.map((item: any) => {
          if (typeof item === 'string') return { Status: item };
          if (!item || typeof item !== 'object') return { Status: String(item) };
          if (item.Status) return { Status: item.Status };
          if (item.status) return { Status: item.status };
          if (item.statusName) return { Status: item.statusName };
          const first = Object.values(item).find(v => typeof v === 'string');
          return { Status: first ? String(first) : JSON.stringify(item) };
        });
        this.UserCallStatusList = normalized;
        this.UserCallStatusTypeList = this.UserCallStatusList;
        this.filteredUserCallStatusTypeList = this.UserCallStatusTypeList;
        this.cdr.markForCheck();
      }
    );
    this.userCallStatusFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      let search = this.userCallStatusFilterControl.value;
      if (!search) {
        this.filteredUserCallStatusTypeList = this.UserCallStatusTypeList.slice();
      } else {
        search = search.toLowerCase();
        this.filteredUserCallStatusTypeList = this.UserCallStatusTypeList.filter(s => s['Status'].toLowerCase().indexOf(search) > -1);
      }
    });
  }

  // Payment Type / Type of Service
  paymentList: any;
  paymentTypeList: any;
  filteredPayemntTypeList: any;
  public paymentFilterControl: UntypedFormControl = new UntypedFormControl();

  getPaymentList() {
    this.paymentTypeService.getAllPaymentModeDropDown().subscribe(res => {
      this.paymentList = res;
      this.paymentTypeList = res;
      this.filteredPayemntTypeList = this.paymentTypeList;
      this.cdr.markForCheck();
    });
    this.paymentFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      let search = this.paymentFilterControl.value;
      if (!search) {
        this.filteredPayemntTypeList = this.paymentTypeList.slice();
      } else {
        search = search.toLowerCase();
        this.filteredPayemntTypeList = this.paymentTypeList.filter(b => b['name'].toLowerCase().indexOf(search) > -1);
      }
    });
  }

  // Supplier
  supplierList: any = [];
  supplierTypeList: any = [];
  filteredsupplierTypeList: any = [];
  supplierFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllSupplierList() {
    this.posSupplierService.getAllsupplierDropDown().subscribe(data => {
      this.supplierList = data;
      this.supplierTypeList = data;
      this.filteredsupplierTypeList = this.supplierTypeList;
      this.cdr.markForCheck();
    });
    this.supplierFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      let search = this.supplierFilterControl.value;
      if (!search) {
        this.filteredsupplierTypeList = this.supplierTypeList.slice();
      } else {
        search = search.toLowerCase();
        this.filteredsupplierTypeList = this.supplierTypeList.filter(s => s['name'].toLowerCase().indexOf(search) > -1);
      }
    });
  }

  // Warehouse
  warehouseList: any = [];
  warehouseTypeList: any = [];
  filteredWarehouseTypeList: any = [];
  warehouseFilterControl: UntypedFormControl = new UntypedFormControl();

  getAllWareHouseList() {
    this.poswarehouseService.getAllWarehouseDropDown().subscribe(data => {
      this.warehouseList = data;
      this.warehouseTypeList = data;
      this.filteredWarehouseTypeList = this.warehouseTypeList;
      this.cdr.markForCheck();
    });
    this.warehouseFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      let search = this.warehouseFilterControl.value;
      if (!search) {
        this.filteredWarehouseTypeList = this.warehouseTypeList.slice();
      } else {
        search = search.toLowerCase();
        this.filteredWarehouseTypeList = this.warehouseTypeList.filter(w => w['name'].toLowerCase().indexOf(search) > -1);
      }
    });
  }

  // Deal Stage
  dealStatusList: any;
  dealStatusTypeList: any;
  filteredlDealStatusTypeList: any;
  public dealStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getDealStage() {
    this.dealsStageService.getAllDealsStagesDropDown(4).subscribe(res => {
      this.dealStatusList = res;
      this.dealStatusTypeList = res;
      this.filteredlDealStatusTypeList = this.dealStatusTypeList;
      this.cdr.markForCheck();
    });
    this.dealStatusFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      let search = this.dealStatusFilterControl.value;
      if (!search) {
        this.filteredlDealStatusTypeList = this.dealStatusTypeList.slice();
      } else {
        search = search.toLowerCase();
        this.filteredlDealStatusTypeList = this.dealStatusTypeList.filter(s => s['statusName'].toLowerCase().indexOf(search) > -1);
      }
    });
  }

  // Tracker
  trackerList: any = [];
  trackerTypeList: any = [];
  filteredTrackerTypeList: any = [];

  getTrackerDropDownList() {
    this.trackerService.getAllTrackerDropDownCache().subscribe((res: any) => {
      this.trackerList = res;
      this.trackerTypeList = res;
      this.filteredTrackerTypeList = this.trackerTypeList;
      this.cdr.markForCheck();
    });
  }

  // Task Status
  taskStatusList: any = [];
  taskStatusTypeList: any = [];
  filteredTaskStatusTypeList: any = [];

  getTaskStatusDownList() {
    this.taskStatusService.getAlltaskStatusDropDown(0).subscribe((res: any) => {
      this.taskStatusList = res;
      this.taskStatusTypeList = res;
      this.filteredTaskStatusTypeList = this.taskStatusTypeList;
      this.cdr.markForCheck();
    });
  }

  // Priority
  priorityList: any = [];
  priorityTypeList: any = [];
  filteredPriorityTypeList: any = [];

  getPriorityDropDownList() {
    this.priorityService.getAllPriorityDropDownCache().subscribe((res: any) => {
      this.priorityList = res;
      this.priorityTypeList = res;
      this.filteredPriorityTypeList = this.priorityTypeList;
      this.cdr.markForCheck();
    });
  }

  zone: TimezoneOption[] = TIMEZONE_ZONES;
  filteredZones: TimezoneOption[] = TIMEZONE_ZONES;
  timeZoneFilterControl: UntypedFormControl = new UntypedFormControl();

  initTimeZones() {
    const lbl = (this.data?.label || '').toString().toLowerCase();
    const isTz = lbl === 'time zone' || lbl === 'timezone' || this.data?.element?.field_key === 'time_zone';

    if (!isTz) {
      return;
    }

    this.zone = TIMEZONE_ZONES;
    this.filteredZones = this.zone;

    if (this.data?.value) {
      const current = this.data.value.toString().trim().toLowerCase();
      let match = this.zone.find((z: TimezoneOption) => z.value.toLowerCase() === current);
      if (match) {
        this.data.value = match.value;
        this.cdr.detectChanges();
      }
    }

    this.timeZoneFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
      if (val) {
        this.filteredZones = this.zone.filter((z: TimezoneOption) =>
          z.label.toLowerCase().includes(val.toLowerCase()) ||
          z.value.toLowerCase().includes(val.toLowerCase())
        );
      } else {
        this.filteredZones = this.zone;
      }
    });
  }

  locationStates: any[] = [];
  filteredLocationStates: any[] = [];
  stateFilterControl: UntypedFormControl = new UntypedFormControl();

  locationCities: any[] = [];
  filteredLocationCities: any[] = [];
  cityFilterControl: UntypedFormControl = new UntypedFormControl();

  initLocationData() {
    const lbl = (this.data.label || '').toLowerCase();

    if (lbl === 'state') {
      const currentCountry = this.data.element?.isCustomizedValue?.Country || this.data.element?.country;
      if (currentCountry) {
        this.countryStateCityService.getAllCountries().pipe(take(1)).subscribe((countries: any) => {
          const countryObj = countries.find((c: any) =>
            c.name?.toLowerCase() === currentCountry.toLowerCase()
          );
          const cId = countryObj ? (countryObj.id || countryObj) : null;
          if (cId) {
            this.countryStateCityService.getStatesByCountry(cId).pipe(take(1)).subscribe((states: any) => {
              this.locationStates = states;
              this.filteredLocationStates = states;
            });
          }
        });
      }

      this.stateFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
        if (!val) {
          this.filteredLocationStates = this.locationStates;
        } else {
          const search = val.toLowerCase();
          this.filteredLocationStates = this.locationStates.filter(s => s.name?.toLowerCase().includes(search));
        }
      });
    }

    if (lbl === 'city') {
      const currentCountry = this.data.element?.isCustomizedValue?.Country || this.data.element?.country;
      const currentState = this.data.element?.isCustomizedValue?.State;

      if (currentCountry && currentState) {
        this.countryStateCityService.getAllCountries().pipe(take(1)).subscribe((countries: any) => {
          const countryObj = countries.find((c: any) =>
            c.name?.toLowerCase() === currentCountry.toLowerCase()
          );
          const cId = countryObj ? (countryObj.id || countryObj) : null;
          if (cId) {
            this.countryStateCityService.getStatesByCountry(cId).pipe(take(1)).subscribe((states: any) => {
              const stateObj = states.find((s: any) => s.name?.toLowerCase() === currentState.toLowerCase());
              const sId = stateObj ? (stateObj.id || stateObj) : null;
              if (sId) {
                this.countryStateCityService.getCitiesByState(cId, sId).pipe(take(1)).subscribe((cities: any) => {
                  this.locationCities = cities;
                  this.filteredLocationCities = cities;
                });
              }
            });
          }
        });
      }

      this.cityFilterControl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
        if (!val) {
          this.filteredLocationCities = this.locationCities;
        } else {
          const search = val.toLowerCase();
          this.filteredLocationCities = this.locationCities.filter(c => c.name?.toLowerCase().includes(search));
        }
      });
    }
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
